/* RESPONSIBLE TEAM: team-channels */
import Model, { attr } from '@ember-data/model';
import { inject as service } from '@ember/service';

export default class EmailConversationHistorySettings extends Model {
  @service appService;

  @attr('string') appId;
  @attr('boolean') removeConversationHistory;
  @attr('boolean') removeConversationHistoryInNotifications;
}
